export const openNewTab = (path) => {
    window.open(path)
}